import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      loadingTikrinti: false,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'prasymasID', 'pazymaID', 'showCheckErrors']),
  },
  methods: {
    checkErrors() {
      this.loading = true
      this.$axios
        .get(`objektas/${this.objektasID}/validacija`)
        .then(res => {
          this.$store.dispatch('checkErrors', res.data.klaidos)
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    checkNtrErrors(withScroll = true) {
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/validacija`)
        .then(res => {
          this.$store.dispatch('checkErrors', res.data.klaidos)
          if (withScroll) {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth',
            })
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.loadingTikrinti = false
        })
    },
    checkPazymaErrors(withScroll = true) {
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/pazyma/${this.pazymaID}/validacija`)
        .then(res => {
          this.$store.dispatch('checkErrors', res.data.klaidos)
          if (withScroll) {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth',
            })
          }
          if (this.showPazymaTurtas) {
            this.reloadTurtas()
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.loadingTikrinti = false
        })
    },
    updateErrors() {
      if (this.showCheckErrors) {
        this.checkNtrErrors(false)
      }
    },
  },
}
